import { useEffect, useState } from "react";
import { CloudOff, RefreshCw } from "lucide-react";
import { subscribeOffline } from "@/lib/offline";

export default function OfflineBar() {
  const [s, setS] = useState({ online: true, pending: 0, syncing: false });
  useEffect(() => subscribeOffline(setS), []);
  const offline = !s.online;
  if (!offline && !s.syncing) return null;
  return (
    <div
      data-testid="offline-bar"
      className="fixed top-2 left-1/2 -translate-x-1/2 z-[60] w-max max-w-[calc(100vw-1rem)] whitespace-nowrap flex items-center gap-2 rounded-full bg-[#1E1E1E]/95 backdrop-blur border border-[#3F3F46] px-3.5 py-1.5 text-xs text-[#E5E7EB] shadow-lg pointer-events-none"
      style={{ marginTop: "env(safe-area-inset-top)" }}
    >
      {offline ? <CloudOff className="h-3.5 w-3.5 text-[#F59E0B]" /> : <RefreshCw className="h-3.5 w-3.5 text-[#3B82F6] animate-spin" />}
      <span data-testid="offline-bar-text">
        {offline ? "Offline — changes will sync" : "Syncing changes…"}
        {s.pending > 0 && <span className="text-[#9CA3AF]"> · {s.pending} pending</span>}
      </span>
    </div>
  );
}
